import { getTimeZones } from '@vvo/tzdb'

export default {
    computed: {
        defaultTimezoneFromClientOffset () {
            const timezone = { value: 'America/Los_Angeles', text: '' }
            const offset = -(new Date()).getTimezoneOffset()
            const candidateTimezone = getTimeZones().filter(tz => tz.currentTimeOffsetInMinutes === offset)[0]
            timezone.text = candidateTimezone.rawFormat
            timezone.value = candidateTimezone.name
            try {
              timezone.value = (Intl.DateTimeFormat().resolvedOptions().timeZone)
              timezone.text = getTimeZones().find(tz => tz.name === timezone.value || tz.group.includes(timezone.value))?.rawFormat ?? ''
            } catch (e) {
              // Intl API not supported
            } return timezone
          },
    },
}
